export default __webpack_public_path__ + "static/media/Avatar-3-noback.ef603103.png";